import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError((err) => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                localStorage.removeItem('currentUser');
                location.reload(true);
            }
            const error = err.error.message || err.statusText;
            return _throw(error);
        }));
    }
}



// WEBPACK FOOTER //
// ./src/app/error.interceptor.ts